module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/defaults/default-user-avatar.png?b6cd494fadca854e4f07397648547beb";